import React from "react";
import _ from "lodash";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";

import PlanningForm from "./PlanningForm";
import Results from "./Results";

import { history } from "../store";
import Seo from "./Seo";

class RoutePlanner extends React.Component {
  constructor(props) {
    super(props);
    this.backButton = null;

    this.setRef = (element) => {
      this.backButton = element;
    };

    this.focusOn = () => {
      setTimeout(() => {
        if (this.backButton) this.backButton.focus();
      }, 1000);
    };
  }

  locationMarkers = () => {
    let markers = this.props.locations.map((location, i) => {
      // Only add marker if there is a location
      if (!location.lat || !location.lng) {
        return null;
      }

      const label = {
        labelContent: location.name.split(",")[0], // use first part of address
        labelClass: "marker-with-label",
        labelAnchor: { x: -15, y: 0 },
      };
      let icon;
      switch (i) {
        case this.props.locations.length - 1:
          icon = {
            url: `${window.ROOT}${window.PORT}/images/markers/checkered_flag.png`,
            size: { width: 26, height: 32 },
            anchor: { x: 8, y: 15 },
          };
          label.labelAnchor = { x: -10, y: 0 };
          break;
        default:
          icon = {
            url: `${window.ROOT}${window.PORT}/images/markers/map_waypoint.png`,
            size: { width: 19, height: 19 },
            anchor: { x: 10, y: 10 },
          };
          label.labelAnchor = { x: -15, y: 12 };
      }

      return {
        location: {
          lat: location.lat,
          lng: location.lng,
        },
        icon,
        label,
      };
    });
    markers = _.without(markers, null);

    this.props.addMarkers("routePlanner", markers);
  };

  cleanup = (clearMap = false) => {
    this.props.cleanupRoutePlanning(clearMap);
  };

  componentDidMount() {
    this.locationMarkers();

    const hasResults =
      this.props.currentJourney.currentJourney && this.props.cycleRoutes.gotData
        ? true
        : false;
    if (hasResults) {
      this.cleanup();
    }
  }

  componentWillUnmount() {
    // Get rid of any routes that have been plotted when leaving component.
    this.props.cleanupRoutePlanning(true);
  }

  componentDidUpdate(prevProps) {
    // New name (eg from GeoLocation)
    const newLocations = !_.isEqual(this.props.locations, prevProps.locations);
    const newURL = !_.isEqual(
      this.props.location.pathname,
      prevProps.location.pathname
    );
    if (newLocations || newURL) {
      const hasResults =
        this.props.currentJourney.currentJourney &&
        this.props.cycleRoutes.gotData
          ? true
          : false;
      if (hasResults) {
        this.cleanup();
      }

      this.locationMarkers();
    }

    // New results
    const newResults =
      this.props.cycleRoutes !== prevProps.cycleRoutes &&
      _.size(this.props.cycleRoutes) > 0;
    if (newResults) {
      this.props.setCurrent("balanced");

      this.focusOn();

      const currentQuery = history.getCurrentLocation().query;
      const query = { ...currentQuery };

      history.push({ query: { ...query } });
    }
  }

  render() {
    const hasResults =
      this.props.currentJourney.currentJourney && this.props.cycleRoutes.gotData
        ? true
        : false;

    return (
      <div className="sidebar-content-vertical-container">
        <Seo
          title="Cycle route planner for the West of England"
          desc="Plan your bike journey and find the most direct, quietest, and more balanced routes."
        />

        <CSSTransitionGroup
          transitionName="slide-fade"
          transitionAppear={true}
          transitionAppearTimeout={400}
          transitionEnterTimeout={400}
          transitionLeaveTimeout={400}
        >
          {!hasResults && <PlanningForm {...this.props} />}

          {hasResults && (
            <div className="main-title-wrapper">
              <h1 className="main-title">Your Route</h1>
            </div>
          )}

          {hasResults && (
            <button
              className="back-button"
              onClick={(e) => {
                e.preventDefault();
                this.cleanup();
              }}
              ref={this.setRef}
              tabIndex="0"
            >
              <svg className="icon" aria-hidden="true">
                <use xlinkHref="#arrow_carrot-left" />
              </svg>
              <span>Back to Route Planner</span>
            </button>
          )}

          {hasResults && (
            <div className="large-content">
              <Results
                showbikeParking={window.innerWidth > 1000}
                {...this.props}
              />
            </div>
          )}
        </CSSTransitionGroup>
      </div>
    );
  }
}

export default RoutePlanner;



// WEBPACK FOOTER //
// ./src/components/RoutePlanning.js